import { Injectable } from '@angular/core';
import {LocalStorageService} from "./local-storage.service";

export interface IPaginationPosition {
  page:string;
  id?:number;
}

@Injectable({
  providedIn: 'root'
})
export class PaginationCacheService {

  constructor(private localStorage:LocalStorageService) { }

  get position():IPaginationPosition {
    const pagination = this.localStorage.get("pagination-page");
    if (pagination) {
      this.localStorage.remove("pagination-page");
      return pagination;
    }
  }

}
